import { Skeleton } from '@mui/material';

const SkeletonDashboard = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        heigth: '90%',
      }}>
      {/* <span style={{ fontSize: '30px', fontWeight: '500' }}>Dashboard Loading...</span>
                    <Waveform size={50} lineWeight={3.5} speed={1} color='black' /> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '50px',
          margin: '10px 20px 20px 20px',
        }}>
        <Skeleton variant='rectangular' width='23%' height='125px' style={{ borderRadius: '20px' }} />
        <Skeleton variant='rectangular' width='23%' height='125px' style={{ borderRadius: '20px' }} />
        <Skeleton variant='rectangular' width='23%' height='125px' style={{ borderRadius: '20px' }} />
        <Skeleton variant='rectangular' width='23%' height='125px' style={{ borderRadius: '20px' }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Skeleton
            variant='rectangular'
            width='48%'
            height='400px'
            style={{ marginBottom: '10px', borderRadius: '20px' }}
          />
          <Skeleton
            variant='rectangular'
            width='48%'
            height='400px'
            style={{ marginBottom: '10px', borderRadius: '20px' }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            gap: '20px',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Skeleton variant='rectangular' width='48%' height='400px' style={{ borderRadius: '20px' }} />
          <Skeleton variant='rectangular' width='48%' height='400px' style={{ borderRadius: '20px' }} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonDashboard;
